import { render, staticRenderFns } from "./error-while-fetching-projects.vue?vue&type=template&id=aa19fd52&scoped=true&"
var script = {}
import style0 from "./error-while-fetching-projects.vue?vue&type=style&index=0&id=aa19fd52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa19fd52",
  null
  
)

export default component.exports